import React from "react";
import Button from "./Button";
import { CTA_URL, LANDING_COPY } from "../constants";

const FinalCta: React.FC = () => {
  const { finalCta } = LANDING_COPY;

  return (
    <section id="acceso" className="py-20 md:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl py-16 md:py-20 px-6 md:px-10">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/90 via-primary to-secondary/90" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(232,200,7,0.12),_transparent_45%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(0,0,0,0.14),_transparent_55%)]" />

          <div className="relative max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white font-display font-bold mb-10 leading-tight text-shadow-subtle">
              {finalCta.title}
            </h2>

            <Button
              href={CTA_URL}
              size="lg"
              showArrow
              className="bg-accent hover:bg-accent-dark text-text-primary shadow-xl hover:shadow-2xl btn-press"
            >
              {finalCta.button}
            </Button>

            <p className="text-sm text-white/75 mt-5 font-medium">
              {finalCta.formNote}
            </p>

            <p className="text-accent font-semibold mt-6 text-base">
              {finalCta.microcopy}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
